import { render, staticRenderFns } from "./EventDetailModal.vue?vue&type=template&id=c0d7474c&scoped=true"
import script from "./EventDetailModal.vue?vue&type=script&lang=js"
export * from "./EventDetailModal.vue?vue&type=script&lang=js"
import style0 from "./EventDetailModal.vue?vue&type=style&index=0&id=c0d7474c&prod&module=true&scoped=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "c0d7474c",
  null
  
)

export default component.exports